import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from 'vue'
import { TagApi } from '~/components'


export default /*#__PURE__*/_defineComponent({
  __name: 'tags',
  setup(__props) {

const tagsList = ref<TagApi[]>([
  {
    path: '/home',
    meta: {
      title: '首页',
      isAffix: true
    }
  },
  {
    path: '/user',
    meta: {
      title: '用户管理',
      isAffix: false
    }
  },
  {
    path: '/role',
    meta: {
      title: '角色管理',
      isAffix: false
    }
  },
  {
    path: '/other',
    meta: {
      title: '其 他xxxxxxxxxxxx',
      isAffix: false
    }
  }
])

const onSelect = (val: TagApi) => {
  console.log('select')
}

let n = 0
const add = (val: string) => {
  tagsList.value.push({ path: `${n++}`, meta: { title: `val-${n++}`, isAffix: false } })
}

const refresh = () => {
  console.log('refresh')
}

const close = (tag: TagApi) => {
  console.log('close')
}

const closeOther = (tag: TagApi) => {
  console.log('closeOther')
}

const closeAll = () => {
  console.log('closeAll')
}

const fullScreen = () => {
  console.log('fullScreen')
}

return (_ctx: any,_cache: any) => {
  const _component_u_tags = _resolveComponent("u-tags")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_u_tags, {
      modelValue: tagsList.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tagsList).value = $event)),
      classic: "",
      onSelect: onSelect,
      onRefresh: refresh,
      onClose: close,
      onCloseOther: closeOther,
      onCloseAll: closeAll,
      onFullScreen: fullScreen
    }, null, 8, ["modelValue"]),
    _createVNode(_component_el_button, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (add('b')))
    }, {
      default: _withCtx(() => [
        _createTextVNode("add")
      ]),
      _: 1
    })
  ], 64))
}
}

})